var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "raft-js"
    }
  }, [_vm.showElement ? _c('b-container', [_c('router-view', {
    on: {
      "form-error-message": _vm.setError,
      "submit-form-data": _vm.submitFormData
    }
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }